import { render, staticRenderFns } from "./detailsTopic.vue?vue&type=template&id=54cf639f&scoped=true"
import script from "./detailsTopic.vue?vue&type=script&lang=js"
export * from "./detailsTopic.vue?vue&type=script&lang=js"
import style0 from "./detailsTopic.vue?vue&type=style&index=0&id=54cf639f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf639f",
  null
  
)

export default component.exports